import { createSelector } from '@reduxjs/toolkit'
import { RootState } from '../rootState'

export const getCurrentUser = createSelector(
  (state: RootState) => state.user,
  user => (user?.email ? user : null),
)
